import * as React from "react"
import { Grid } from '@material-ui/core';
import { Link } from 'react-router-dom';

export default class ActiveUsersComponent extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
        }
    }

    render() {
        return (
            <Grid item={true} xs={12} sm={3}>
                <Link to={{ pathname: `/users` }}>
                    <div>
                        <div className="panel panel-blue">
                            <div className="panel-body">
                                {this.props.ActiveUsers}
                            </div>
                            <div className="panel-heading">
                                Active Users
                            </div>
                        </div>
                    </div>
                </Link>
            </Grid>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/dashboard/ActiveUsersComponent.tsx